import { useState } from "react";
import { faqs } from "@/mocks/heigua";
import SectionHeading from "./SectionHeading";

export default function Faq() {
  const [open, setOpen] = useState<number>(0);

  return (
    <section id="faq" className="border-y border-background-200 bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-5 lg:gap-14">
          <div className="lg:col-span-2">
            <SectionHeading
              index="肆"
              eyebrow="Q & A"
              title="关于考古，常见问题"
              subtitle="关于旧瓜考古、档案整理与检索方式的几个高频疑问，一次性讲清楚。"
            />
            <a
              href="#about"
              className="mt-6 inline-flex items-center gap-2 whitespace-nowrap text-sm font-medium text-primary-600 hover:text-primary-700"
            >
              仍有疑问？看看关于本站的原则
              <i className="ri-arrow-right-line" />
            </a>
          </div>

          <div className="flex flex-col gap-3 lg:col-span-3">
            {faqs.map((f, i) => {
              const isOpen = open === i;
              return (
                <div
                  key={f.q}
                  className={`rounded-lg border bg-background-50 transition-colors ${
                    isOpen ? "border-primary-300" : "border-background-200"
                  }`}
                >
                  <button
                    type="button"
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    aria-expanded={isOpen}
                    className="flex w-full items-center gap-3 px-5 py-4 text-left"
                  >
                    <span
                      className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-xs font-semibold ${
                        isOpen ? "bg-primary-500 text-background-50" : "bg-secondary-100 text-secondary-900"
                      }`}
                    >
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <span className="flex-1 font-heading text-sm font-bold text-foreground-950 md:text-base">
                      {f.q}
                    </span>
                    <i
                      className={`ri-arrow-down-s-line text-xl text-foreground-500 transition-transform duration-300 ${
                        isOpen ? "rotate-180" : ""
                      }`}
                    />
                  </button>
                  <div
                    className={`grid transition-all duration-300 ease-in-out ${
                      isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                    }`}
                  >
                    <div className="overflow-hidden">
                      <p className="border-t border-background-100 px-5 pb-5 pl-[3.75rem] text-sm leading-relaxed text-foreground-600">
                        {f.a}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}